import { useConfig } from "../../../../data/useConfig";
import {
  GridItemImage,
  GridItemPrice,
  GridItemTitle,
  GridSuggestionContainer,
  SuggestionGridItem,
} from "../styles";

const GridTemplate = ({ onSuggestionClick, suggestedTerms }) => {
  const { autocompleteConfigs } = useConfig();
  const showPrices = autocompleteConfigs?.showPrices ?? true;

  return (
    <GridSuggestionContainer>
      {suggestedTerms.map(({ label, value, params }) => (
        <SuggestionGridItem
          className="bn-search__suggestion-grid-item"
          key={crypto.randomUUID()}
          onClick={() => onSuggestionClick({ label, value, params })}
          data-product-id={`${params.product_id}`}
          data-product-sku={`${params.sku}`}
        >
          <GridItemImage
            className="bn-search__suggestion-grid-image"
            alt={label}
            src={params?.images?.[0]}
          />

          <GridItemTitle className="bn-search__suggestion-grid-title">
            {label}
          </GridItemTitle>

          {showPrices && (
            <GridItemPrice
              id="bn-suggestion-price-container"
              className="bn-search__suggestion-grid-price"
            >
              {params?.prices?.price_from > 0 && (
                <span className="bn-search__suggestion-price-from">
                  R$
                  {params?.prices?.price_from
                    ?.toFixed(2)
                    .toString()
                    .replace(".", ",")}
                </span>
              )}

              {params?.prices?.price_to > 0 && (
                <span className="bn-search__suggestion-price-to">
                  R$
                  {params?.prices?.price_to
                    ?.toFixed(2)
                    .toString()
                    .replace(".", ",")}
                </span>
              )}

              {params?.prices?.price_avista > 0 && (
                <span className="bn-search__suggestion-price-avista">
                  R$
                  {params?.prices?.price_avista
                    ?.toFixed(2)
                    .toString()
                    .replace(".", ",")}
                </span>
              )}

              <span className="bn-search__suggestion-installments">
                <span className="bn-search__suggestion-installments-price-to">
                  R$
                  {params?.prices?.price_to
                    ?.toFixed(2)
                    .toString()
                    .replace(".", ",")}
                </span>

                {typeof params?.prices?.price_inst_months === "number" && (
                  <span className="bn-search__suggestion-installments-months">
                    {params?.prices?.price_inst_months}x
                  </span>
                )}

                {typeof params?.prices?.price_inst_amount === "number" && (
                  <span className="bn-search__suggestion-installments-amount">
                    R$
                    {params?.prices?.price_inst_amount
                      ?.toFixed(2)
                      .toString()
                      .replace(".", ",")}
                  </span>
                )}
              </span>
            </GridItemPrice>
          )}
        </SuggestionGridItem>
      ))}
    </GridSuggestionContainer>
  );
};

export default GridTemplate;
